// ── expenseCategoryMap.js — 거래장부 매입 → 손익 분석 5개 비용 카테고리 매핑 ──
// 거래장부 transaction의 category({major, sub})를 ProfitLoss의 5개 bucket으로 변환.
//
// 5개 bucket (ProfitLoss record.costs):
//   - ingredients : 식재료비
//   - labor       : 인건비 (급여·일당·4대보험·복리후생)
//   - rent        : 임대료·관리비
//   - utilities   : 공과금 (전기·가스·수도·통신)
//   - other       : 결제수수료·세금·차량·마케팅·기타

export function mapCategoryToBucket(category) {
  const major = String(category?.major || '').toLowerCase();
  const sub = String(category?.sub || '').toLowerCase();

  if (major === 'material') return 'ingredients';
  if (major === 'labor') return 'labor';   // salary / daily_wage / social_insurance / welfare / 등
  if (major === 'operation') {
    if (sub === 'rent') return 'rent';
    if (sub === 'utilities' || sub === 'communication') return 'utilities';
    // fees / taxes_dues / vehicle / 기타 → other
    return 'other';
  }
  // marketing / etc / 미분류 → other
  return 'other';
}

// ── 카테고리별 매입 합산 (월 단위) ──
// transactions[] (type='expense', 'YYYY-MM' filter) → { ingredients, labor, rent, utilities, other }
export function aggregateMonthlyExpenses(transactions, monthPrefix) {
  const buckets = { ingredients: 0, labor: 0, rent: 0, utilities: 0, other: 0 };
  for (const t of (transactions || [])) {
    if (t?.type !== 'expense') continue;
    if (!t?.date || !t.date.startsWith(monthPrefix)) continue;
    const bucket = mapCategoryToBucket(t.category);
    const amount = (Number(t.supply) || 0) + (Number(t.vat) || 0);
    buckets[bucket] += amount;
  }
  // 반올림 (소수점 깔끔하게)
  Object.keys(buckets).forEach(k => { buckets[k] = Math.round(buckets[k]); });
  return buckets;
}

// ── 표시 라벨 (UI용) ──
export const BUCKET_LABELS = {
  ingredients: '식재료비',
  labor: '인건비',
  rent: '임대료',
  utilities: '공과금',
  other: '기타',
};

export const BUCKET_KEYS = ['ingredients', 'labor', 'rent', 'utilities', 'other'];
